import * as React from 'react';
import { HelpBlock } from 'react-bootstrap';

export const CustomInputError = ({ errorMessage}) => {
  return (
    <HelpBlock>{errorMessage}</HelpBlock>
  )
}
